import { Box, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { leaderUrl } from "@outschool/routes";
import { TrackingPage } from "@outschool/ui-legacy-component-library";
import React from "react";

import SimpleLayout from "../../layouts/SimpleLayout";
import TeacherHeader from "../TeacherHeader";
import {
  About,
  ProfileSection,
  TeacherMetaTags,
} from "./TeacherProfileSummary";

export default function InactiveTeacherProfile({
  leader,
  userMode,
  error,
  isMobile,
  isTablet,
  userTimeZone,
}: $TSFixMe) {
  const { t } = useTranslation(
    "client\\components\\teacher\\TeacherProfile\\InactiveTeacherProfile",
  );
  return (
    <TrackingPage
      name="leaderProfile"
      uniqueId="leaderProfile"
      leader={leader}
      sharedProperties={{
        educatorTiers: leader?.educatorTiers.join(",") || "",
      }}
    >
      {setImpressionNode => (
        <SimpleLayout
          error={error}
          userMode={userMode}
          // @ts-ignore TS(2345): Argument of type 'HTMLDivElement | null' is not as... Remove this comment to see the full error message
          ref={node => setImpressionNode(node)}
          allowCategoriesNavbar
        >
          <Box
            sx={{
              marginBottom: "120px",
            }}
          >
            <TeacherMetaTags
              leader={leader}
              numberOfUpcomingListings={0}
              numberOfOtherListings={0}
              profileUrl={leaderUrl(leader.uid, leader.leader_link)}
            />
            <ProfileSection fullWidth={true} center={isMobile || isTablet}>
              <TeacherHeader
                leader={leader!}
                showActionsInColumnForLargeScreens
              />
            </ProfileSection>
            {leader.teacher_approved_at && (
              <ProfileSection>
                <Box
                  flex
                  sx={{
                    alignItems: "flex-start",
                    paddingY: "64px",
                  }}
                >
                  <About leader={leader} userTimeZone={userTimeZone} />
                </Box>
              </ProfileSection>
            )}
            <ProfileSection>
              <Box
                flex
                sx={{
                  alignItems: "flex-start",
                  paddingY: "64px",
                }}
              >
                <Typography>
                  {t(
                    "This teacher is not offering classes on Outschool at this time.",
                  )}
                </Typography>
              </Box>
            </ProfileSection>
          </Box>
        </SimpleLayout>
      )}
    </TrackingPage>
  );
}
